import i18n from 'utils/i18n'
import { createRequestInterceptor } from '../createInterceptor'

export const languageInterceptor = createRequestInterceptor((_queryArgs) => (config) => {
  config.headers['Accept-Language'] = i18n.language
  return config
})
